import { useEffect, useState } from "react";
import DayPicker, { DateUtils } from "react-day-picker";
import "react-day-picker/lib/style.css";
import MomentLocaleUtils from "react-day-picker/moment";
import "moment/locale/zh-hk";

export default function DatePickerRange({
  filterDateRange,
  startDatePicked,
  endDatePicked,
}) {
  const [startDate, setStartDate] = useState(startDatePicked);
  const [endDate, setEndDate] = useState(endDatePicked);
  const modifiers = { start: startDate, end: endDate };

  useEffect(() => {
    if (startDatePicked && endDatePicked) {
      setStartDate(startDatePicked);
      setEndDate(endDatePicked);
    }
  }, []);

  useEffect(() => {
    filterDateRange(startDate, endDate);
  }, [startDate, endDate]);

  const handleDayClick = (day) => {
    const range = DateUtils.addDayToRange(day, {
      from: startDate,
      to: endDate,
    });
    // console.log(range);
    setStartDate(range.from);
    setEndDate(range.to);
  };

  return (
    <DayPicker
      localeUtils={MomentLocaleUtils}
      locale="zh"
      className="Selectable"
      numberOfMonths={1}
      selectedDays={[startDate, { from: startDate, to: endDate }]}
      modifiers={modifiers}
      onDayClick={handleDayClick}
    />
  );
}
